/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CarveOutListResponse } from './CarveOutListResponse';
import {
    CarveOutListResponseFromJSON,
    CarveOutListResponseFromJSONTyped,
    CarveOutListResponseToJSON,
    CarveOutListResponseToJSONTyped,
} from './CarveOutListResponse';

/**
 * 
 * @export
 * @interface FindAllCarveOuts200Response
 */
export interface FindAllCarveOuts200Response {
    /**
     * 
     */
    data?: CarveOutListResponse;
}

/**
 * Check if a given object implements the FindAllCarveOuts200Response interface.
 */
export function instanceOfFindAllCarveOuts200Response(value: object): value is FindAllCarveOuts200Response {
    return true;
}

export function FindAllCarveOuts200ResponseFromJSON(json: any): FindAllCarveOuts200Response {
    return FindAllCarveOuts200ResponseFromJSONTyped(json, false);
}

export function FindAllCarveOuts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllCarveOuts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CarveOutListResponseFromJSON(json['data']),
    };
}

export function FindAllCarveOuts200ResponseToJSON(json: any): FindAllCarveOuts200Response {
    return FindAllCarveOuts200ResponseToJSONTyped(json, false);
}

export function FindAllCarveOuts200ResponseToJSONTyped(value?: FindAllCarveOuts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CarveOutListResponseToJSON(value['data']),
    };
}

